import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventFeatureFlags } from '@shared/hooks/useEventFeatureFlags/useEventFeatureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';

type useGuestPageContentRedesignReturnType = Readonly<{
  enabled: boolean;
  loading: boolean;
}>;

export const useGuestPageContentRedesign = (): useGuestPageContentRedesignReturnType => {
  const { eventHandle } = useEventInfo();

  const eventFeatureFlags = useEventFeatureFlags({ eventHandle: eventHandle || '', skip: !eventHandle });
  const isEventEligible = !eventFeatureFlags.loadingEventFeatureFlags && eventFeatureFlags.isEventFeatureFlagEnabled('useGuestPageContentRedesign');

  const [isEnabled, isLoading] = useIsFeatureEnabled('guestPageContentRedesign', {
    skip: !isEventEligible,
  });

  const eventExposure = useMemo(
    () => ({
      enabled: isEnabled,
      loading: isLoading,
    }),
    [isEnabled, isLoading],
  );

  return eventExposure;
};
